<template>
  <div :class="['mp-account-wrapper', this.isActive ? 'active' : '']">
    <i class="avatar" :style="{ backgroundImage: 'url(' + data.avatarUrl + ')' }"/>
    <div class="info">
      <span class="name">{{data.name}}</span>
      <span class="tip">{{data.description}}</span>
    </div>
  </div>
</template>

<script>
import defaultAvatar from '../assets/default_avatar.png'

export default {
  name: 'MpAccount',
  props: {
    isActive: Boolean,
    data: Object,
  },
  watch: {
    data: {
      immediate:true,
      deep: true,
      handler() {
        if (this.data && (!this.data.avatarUrl || !/^http/.test(this.data.avatarUrl))) {
          this.data.avatarUrl = defaultAvatar
        }
      },
    }
  },
};
</script>

<style scoped lang="scss">
.mp-account-wrapper {
  display: flex;
  align-items: center;
  padding-left: 50px;
  margin: 0 auto 20px;
  width: 320px;

  &.active {
    background-image: url('../assets/selected.png');
    background-repeat: no-repeat;
    background-size: 24px;
    background-position: 5px center;
  }

  .avatar {
    width: 60px;
    height: 60px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 20px;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
  }

  .info {
    width: 0;
    flex-grow: 1;
    flex-shrink: 1;
    color: #101010;
  }

  .name {
    display: block;
    font-size: 16px;
    line-height: 25px;
    font-weight: bold;
  }

  .tip {
    display: block;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
